// Global Instructions Rule Applied!
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

// Read shape of the Change Log tab (get_change_log_data → backend
// /change-log/:contextTable/:recordId): one display-ready event per
// audit.logs row rolled up to the record — the RPC does all rendering
// (labels, FK resolution, event titles). Validated before it reaches the
// tab (CLAUDE.md: validate every API response).

export const ChangeLogChangeSchema = z
  .object({
    field: z.string(),
    old: z.string().nullable(),
    new: z.string().nullable()
  })
  .strict()

export const ChangeLogEventSchema = z
  .object({
    id: z.string(),
    date_created: z.string(),
    user_name: z.string(),
    is_agent: z.boolean(),
    operation: z.string(),
    source_table: z.string(),
    event_title: z.string(),
    changes: z.array(ChangeLogChangeSchema)
  })
  .strict()

export type ChangeLogChange = z.infer<typeof ChangeLogChangeSchema>
export type ChangeLogEvent = z.infer<typeof ChangeLogEventSchema>

export function validateChangeLogEvent(data: unknown): ChangeLogEvent {
  try {
    return validateWithZodSchema(ChangeLogEventSchema, data, 'change log event')
  } catch (error) {
    throw new Error(`Change log event validation failed: ${error}`)
  }
}
